var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42857 5C5.63571 5 5 5.63571 5 6.42857V14.2857C5 15.0786 5.63571 15.7143 6.42857 15.7143H14.2857C15.0786 15.7143 15.7143 15.0786 15.7143 14.2857V12.1429H14.2857V14.2857H6.42857V6.42857H14.2857V7.85714H15.7143V6.42857C15.7143 5.63571 15.0786 5 14.2857 5H6.42857ZM10.7143 9.28571C9.92143 9.28571 9.28571 9.92143 9.28571 10.7143V12.8571H10.7143V10.7143H18.5714V18.5714H10.7143V17.1429H9.28571V18.5714C9.28571 19.3643 9.92143 20 10.7143 20H18.5714C19.3643 20 20 19.3643 20 18.5714V10.7143C20 9.92143 19.3643 9.28571 18.5714 9.28571H10.7143Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks);
export default __webpack_public_path__ + "static/media/links.f72c6324bf2bae821f47827d82c86302.svg";
export { ForwardRef as ReactComponent };